module.exports = __webpack_public_path__ + "static/media/bg_7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg_7.png
// module id = 52
// module chunks = 0